export default __webpack_public_path__ + "static/media/hand.3023b15c.svg";